import React from 'react';

const steps = [
  {
    number: "01",
    title: "Select Orbits",
    text: "Define initial and target orbital parameters including altitude, eccentricity, and inclination."
  },
  {
    number: "02",
    title: "Run Transfer Calculation",
    text: "ORBTX computes optimal burn sequence, transfer time, and ΔV using classical mechanics."
  },
  {
    number: "03",
    title: "Analyze & Visualize",
    text: "Review fuel requirements and inspect the 3D trajectory transition in real time."
  }
];

const HowItWorksSection = () => {
  return (
    <section className="py-20 px-4 bg-dark-900/50">
      <div className="max-w-6xl mx-auto">

        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">How It Works</h2>
          <p className="text-gray-400 text-lg">
            Simple workflow. Professional results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-dark-800 p-8 rounded-lg border border-gray-700"
            >
              <div className="text-primary-400 text-3xl font-bold mb-4">
                {step.number}
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white">
                {step.title}
              </h3>
              <p className="text-gray-400">
                {step.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;